module.exports = __webpack_public_path__ + "img/space-station-moon.5b26f4fa.svg";